import { messages } from 'i18n';

export class NetworkError extends Error {
  constructor() {
    super(messages.general.fetchError);
  }
}
